"use client";
import { makeStyles, tokens } from "@fluentui/react-components";
import { useChaptersGetAll } from "../hooks/useChapter";
import { ChapterList } from "../components/chapterlist/ChapterList";
import { useTranslation } from "react-i18next";
import { ChapterListSkeleton } from "../components/skeletons/ChapterListSkeleton";

const useClasses = makeStyles({
  root: {
    overflow: "visible",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    padding: tokens.spacingVerticalM,
  },
});

function ChaptersPage() {
  const classes = useClasses();
  const { t } = useTranslation();

  const { isLoading } = useChaptersGetAll();

  return (
    <div className={classes.root}>
      <h1>{t("chapter")}</h1>

      {!isLoading ? (
        <div>
          <ChapterList />
        </div>
      ) : (
        <ChapterListSkeleton />
      )}
    </div>
  );
}

export default ChaptersPage;
